import { css } from '@genesislcap/web-core';

export const ActivityTodayStyles = css`
  :host {
    /* Add custom styles here if needed */
    --control-bar-height: 45px;
  }

  rapid-flyout::part(flyout) {
    display: flex;
    flex-direction: column;
    width: var(--flyout-width, 500px);
    min-width: 500px;
    max-width: 1000px;
    padding: 0;
    position: fixed;
    top: var(--nav-height);
    height: calc(100vh - var(--nav-height) - 15px);
    max-height: calc(100vh - var(--nav-height) - 15px);
    transition: width 0.1s ease, opacity 0.3s ease, transform 0.3s ease;
  }

  rapid-flyout::part(header) {
    border-bottom: calc(var(--stroke-width) * 1px) solid var(--neutral-stroke-divider-rest);
  }

  rapid-flyout::part(content) {
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  rapid-flyout::part(content),
  rapid-flyout::part(footer) {
    padding: 0;
  }

  tranche-detail-flyout {
    height: 100%;
  }

  ::part(title) {
    padding-left: 10px;
  }

  .activity-today-header {
    display: flex;
    padding: 5px;
    height: var(--control-bar-height);
    background: var(--neutral-layer-2);
  }

  .controls {
    display: flex;
    align-items: center;
    padding-left: 10px;
    gap: 10px;
    color: var(--neutral-foreground-hint);
    background: var(--neutral-layer-2);
  } 

  .activity-today-main-container {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
  }

  .activity-today-grid-area {
    display: flex;
    width: 100%;
    transition: margin-left 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .activity-today-flyout-area {
    background: var(--neutral-layer-1);
    box-shadow: var(--elevation-shadow-flyout);
    height: 100%;
    z-index: 2;
    transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1), width 0.6s cubic-bezier(0.4, 0, 0.2, 1), min-width 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: column;
    position: relative;
    transform: translateX(-100%);
    pointer-events: none;
    opacity: 0;
    width: 0;
    min-width: 0;
  }

  .activity-today-flyout-area.open {
    transform: translateX(0);
    pointer-events: auto;
    opacity: 1;
    width: 420px;
    min-width: 420px;
  }

  .activity-today-flyout-area.closed {
    transform: translateX(-100%);
    pointer-events: none;
    opacity: 0;
    width: 0;
    min-width: 0;
  }

  mbm-grid-pro {
    width: 100%;
    height: calc(100% - var(--control-bar-height) - 10px);
  }

  rapid-label {
    font-size: var(--type-ramp-base-font-size);
  }

  rapid-text-field > rapid-button {
    background-color: color-mix(in srgb, var(--neutral-fill-input-rest), transparent 94%);
    border: unset;
  }

  rapid-text-field {
    margin-bottom: 0px;
  }

  rapid-text-field.text-filter {
    width: 150px;
  }

  rapid-text-field::part(end) {
    margin-inline-end: 0px;
  }


  .flyout-close-row {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    height: 15px;
    align-items: baseline;
    z-index: 10;
    position: relative;
  }

  criteria-segmented-control {
    --neutral-fill-stealth-rest: var(--accent-fill-rest);
  }

  rapid-text-field::part(root) {
    height: calc((((var(--base-height-multiplier) + var(--density)) * var(--design-unit)) - 6) * 1px);
  }

  rapid-select {
    height: calc((((var(--base-height-multiplier) + var(--density)) * var(--design-unit)) - 6) * 1px);
  }

  rapid-button {
    height: calc(((var(--base-height-multiplier) + var(--density)) * var(--design-unit) - 6) * 1px);
  }
`; 
